import { useDispatch, useSelector } from 'react-redux'

const useChangeEducatorToPlanModal = () => {
  const dispatch = useDispatch()
  const reduxData = useSelector((state) => state.modal.plan.changeEducatorToPlanModal)
  const { isOpen } = reduxData

  const setData = (open = false, data = {}) => {
    dispatch({
      type: 'SET_DATA_MODAL_FORM_LIST',
      payload: 'plan.changeEducatorToPlanModal',
      data: {
        ...reduxData,
        ...data,
        isOpen: open
      }
    })
  }

  return {
    ...reduxData,
    open: (data = {}) => {
      setData(true, data)
    },
    close: () => {
      setData(false)
    },
    toggle: () => {
      setData(!isOpen)
    }
  }
}

export default useChangeEducatorToPlanModal
